export default {
  methods: {
    async auth() {
      this.errors = "Successfull";
      this.messageError = false;
      const response = await this.$store.dispatch("login/signIn", this.credentials);
      if (!response) {
        return;
      }
      const tokenInfo = this.$store.getters["login/getTokenInfo"];
      this.setLocalStorageData();
      if (tokenInfo.is_branded) {
        this.changeView("MyLoads");
        return;
      }
      if (response) {
        this.changeView("Dashboard");
      }
    },
    setLocalStorageData() {
      localStorage.setItem('customer', JSON.stringify({}));
      localStorage.setItem('stops', JSON.stringify([]));
      localStorage.setItem('accessorials', JSON.stringify([]));
      localStorage.setItem('cargoValue', JSON.stringify(0));
      localStorage.setItem('lineItems', JSON.stringify([]));
    },
  },
};
